import { useState, useCallback } from "react";
import { EmailData } from "../types";

export type Step = 'table' | 'review';

interface UseStepsReturn {
  currentStep: Step;
  selectedEmail: EmailData | null;
  showTable: () => void;
  showReview: (email: EmailData) => void;
}

export const useSteps = (): UseStepsReturn => {
  const [currentStep, setCurrentStep] = useState<Step>('table');
  const [selectedEmail, setSelectedEmail] = useState<EmailData | null>(null);

  const showTable = useCallback(() => {
    setCurrentStep('table');
    setSelectedEmail(null);
  }, []);

  const showReview = useCallback((email: EmailData) => {
    setCurrentStep('review');
    setSelectedEmail(email);
  }, []);

  return {
    currentStep,
    selectedEmail,
    showTable,
    showReview,
  };
};
